export default __webpack_public_path__ + "static/smp-fbf44036f1edbc12671349a63c6cbde6.webp";